import React, { useState, useEffect } from "react";

// Package Import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  Backdrop,
  Snackbar,
  CircularProgress,
  Alert,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import DatePicker from "react-datepicker";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";

//user import

import {
  BATCH_MAIN_TYPES_ENUM,
  USER_ROLES_ENUM,
  BATCH_CREATE_ENUMS,
  TEMPRATURE_ENUM_ARRAY,
} from "../../../../common/Enums";
import { CustomDateInput } from "../../../../common/Components";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { headersPost } from "../../../../Services/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { createBatchSchema } from "../../../../Services/validations/MinistryPortal/Batch";
import { format } from "date-fns";
import { grey } from "@mui/material/colors";

//constants

const initialValue = {
  reference_number: "",
  lot_number: "",
  main_type: "vaccine",
  sub_type: "pfizer",
  size: "",
  previous_temperature: "",
  expiry_date: "",
  manufacture_date: "",
};

// Component

const IssuedBatch = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [batchArr, setBatchArr] = useState("");
  const [mainTypeValue, setMainTypeValue] = useState("");
  const [subTypeValue, setSubTypeValue] = useState("");
  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      batch: {
        reference_number: values.reference_number,
        lot_number: values.lot_number,
        size: values.size,
        previous_temperature: values.previous_temperature,
        expiry_date: values.expiry_date,
        manufacture_date: values.manufacture_date,
        main_type: BATCH_MAIN_TYPES_ENUM.VACCINES,
        sub_type: values.sub_type,
        batch_type: USER_ROLES_ENUM.ministry,
        action: BATCH_CREATE_ENUMS.ISSUE,
      },
    };
    
    setOpen(true);

    headersPost(MINISTRY_API_ULRS.CREATE_BATCH, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-1);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  useEffect(() => {
    getTypeHandler1();
  }, [subTypeValue, mainTypeValue]);

  const getTypeHandler1 = () => {
    if (subTypeValue && mainTypeValue) {
      const data = {
        batch: {
          manufacture_date: mainTypeValue,
          previous_temperature: subTypeValue,
        },
      };
      setOpen(true);

      headersPost(MINISTRY_API_ULRS.GET_TEMPERATURE, data)
        .then((res) => {
          setOpen(false);
          if (res?.status === 200 && res?.data?.success) {
            setBatchArr(res?.data?.expiry_date);
          } else {
            setAlertOpen(true);
            setAlertMsg(res?.data?.message);
            setAlertIcon("warning");
          }
        })
        .catch((err) => {
          setOpen(false);
          const { response } = err;
          if (response?.status === 401) {
            localStorage.clear();
            navigate(RoutesUrls?.root);
          } else {
            setAlertOpen(true);
            setAlertMsg(response?.statusText);
            setAlertIcon("error");
          }
        });
    } else return;
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{
        p: 2,

        margin: "auto",

        borderRadius: 2,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            // textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Add Inventory
        </Typography>
        <Formik
          initialValues={initialValue}
          onSubmit={formSubmitHanlder}
          validationSchema={createBatchSchema}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 0, sm: 3, md: 5 }}>
                {/* <Grid item > */}
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={350}
                >
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Please enter reference number"
                      type={"text"}
                      name="main_type"
                      disabled
                      onChange={handleChange}
                      error={touched?.main_type && Boolean(errors?.main_type)}
                      helperText={touched?.main_type && errors?.main_type}
                      value={values.main_type}
                      fullWidth
                      // sx={{
                      //   [`.${outlinedInputClasses?.root}`]: {
                      //     borderRadius: 35,
                      //     backgroundColor: `${theme.palette.secondary.dark}`,
                      //   },
                      //   [`.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Please select category"
                      type={"text"}
                      name="sub_type"
                      disabled
                      onChange={handleChange}
                      error={touched?.sub_type && Boolean(errors?.sub_type)}
                      helperText={touched?.sub_type && errors?.sub_type}
                      value={values.sub_type}
                      fullWidth
                      // sx={{
                      //   [`.${outlinedInputClasses?.root}`]: {
                      //     borderRadius: 35,
                      //     backgroundColor: `${theme.palette.secondary.dark}`,
                      //   },
                      //   [`.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Please enter Batch number"
                      type={"text"}
                      name="reference_number"
                      onChange={handleChange}
                      error={
                        touched?.reference_number &&
                        Boolean(errors?.reference_number)
                      }
                      helperText={
                        touched?.reference_number && errors?.reference_number
                      }
                      value={values.reference_number}
                      fullWidth
                      // sx={{
                      //   [`.${outlinedInputClasses?.root}`]: {
                      //     borderRadius: 35,
                      //     backgroundColor: `${theme.palette.secondary.dark}`,
                      //   },
                      //   [`.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Please enter lot number"
                      type={"text"}
                      name="lot_number"
                      onChange={handleChange}
                      error={touched?.lot_number && Boolean(errors?.lot_number)}
                      helperText={touched?.lot_number && errors?.lot_number}
                      value={values.lot_number}
                      fullWidth
                      // sx={{
                      //   [`.${outlinedInputClasses?.root}`]: {
                      //     borderRadius: 35,
                      //     backgroundColor: `${theme.palette.secondary.dark}`,
                      //   },
                      //   [`.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"number"}
                      name="size"
                      onChange={handleChange}
                      error={touched?.size && Boolean(errors?.size)}
                      helperText={touched?.size && errors?.size}
                      value={values.size}
                      placeholder="Please enter quantity"
                      fullWidth
                      // sx={{
                      //   border: "1px solid grey",
                      //   borderRadius: theme.spacing(4),

                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     backgroundColor: `${theme.palette.secondary.dark}`,
                      //     borderRadius: theme.spacing(4),
                      //   },
                      // }}
                    />
                  </Grid>

                  <Grid container marginBottom={5}>
                    <DatePicker
                      selected={values.manufacture_date}
                      minDate={""}
                      maxDate={new Date()}
                      onChange={(date) => {
                        setFieldValue("manufacture_date", date);
                        setMainTypeValue(date);
                      }}
                      // onChange={(e) => {}}
                      // selectsStart
                      placeholderText="Please select manufacturing date"
                      name="manufacture_date"
                      customInput={
                        <CustomDateInput
                          size={"small"}
                          InputProps={{
                            readOnly: true,
                          }}
                          name={"manufacture_date"}
                          helperText={
                            touched?.manufacture_date &&
                            errors?.manufacture_date
                          }
                          error={
                            touched?.manufacture_date &&
                            Boolean(errors?.manufacture_date)
                          }
                        />
                      }
                    />
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      select
                      name="previous_temperature"
                      // color={"text.grayText"}
                      onChange={(date) => {
                        setSubTypeValue(date.target.value);
                        handleChange(date);
                      }}
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      error={
                        touched?.previous_temperature &&
                        Boolean(errors?.previous_temperature)
                      }
                      helperText={
                        touched?.previous_temperature &&
                        errors?.previous_temperature
                      }
                      value={values.previous_temperature}
                      placeholder="Storage temperate"
                      fullWidth
                    >
                      <MenuItem value={""} disabled>
                        Storage Temprature
                      </MenuItem>
                      {TEMPRATURE_ENUM_ARRAY?.map((item, index) => (
                        <MenuItem
                          value={item.value}
                          key={`${index}-request-inventory-${item.value}`}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid container marginBottom={5}>
                    {(batchArr &&
                      (values.expiry_date = format(
                        new Date(batchArr),
                        "MM/dd/yyyy"
                      )) &&
                      null) ||
                      null}
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Expiry date"
                      type={"text"}
                      name="expiry_date"
                      value={values?.expiry_date}
                      onChange={handleChange}
                      disabled
                      error={
                        touched?.expiry_date && Boolean(errors?.expiry_date)
                      }
                      helperText={touched?.expiry_date && errors?.expiry_date}
                      fullWidth
                    />
                  </Grid>

                  <Grid
                    container
                    marginTop={5}
                    display={"flex"}
                    justifyContent={"center"}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      margin={"auto"}
                      sx={{
                        borderRadius: theme.spacing(1),
                        minWidth: "40%",
                      }}
                    >
                      {" "}
                      Done{" "}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        color={alertIcon}
        autoHideDuration={100000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon} color={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default IssuedBatch;
